.container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.header {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--tg-theme-text-color);
  margin-bottom: var(--spacing-xs);
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-sm);
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: var(--spacing-md);
  background: var(--tg-theme-secondary-bg-color);
  border-radius: var(--border-radius);
  border: none;
  cursor: pointer;
  transition: opacity var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.card:active {
  opacity: 0.7;
}

.card:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

.icon {
  font-size: 28px;
  line-height: 1;
}

.nameRow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.name {
  font-size: 13px;
  font-weight: 600;
  color: var(--tg-theme-text-color);
  line-height: 1.3;
}

.description {
  font-size: 12px;
  color: var(--tg-theme-hint-color);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.lock {
  font-size: 10px;
  line-height: 1;
  flex-shrink: 0;
}

.loading {
  display: flex;
  justify-content: center;
  padding: var(--spacing-lg);
  color: var(--tg-theme-hint-color);
  font-size: var(--font-size-sm);
}
